var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 256,
      height: 256,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4B4B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.047,168.92H172.669v-30.031c0-46.055,37.475-83.53,83.53-83.53c42.534,0,77.749,31.969,82.869,73.15 h55.621C389.369,56.758,329.289,0,256.199,0c-76.58,0-138.889,62.308-138.889,138.889v30.031H53.953 c-22.718,0-40.801,19.029-39.644,41.717l14.394,263.691C29.78,495.438,47.21,512,68.347,512h375.306 c21.137,0,38.567-16.562,39.644-37.672l14.395-263.691C498.849,187.949,480.765,168.92,458.047,168.92z M276.618,341.82v57.459 c0,9.893-8.095,17.988-17.988,17.988c-9.894,0-17.989-8.096-17.989-17.988V341.82c-11.579-6.383-19.517-18.561-19.517-32.717 c0-20.713,16.792-37.506,37.506-37.506c20.713,0,37.505,16.793,37.505,37.506C296.135,323.26,288.197,335.438,276.618,341.82z",
    style: {
      fill: "rgb(40, 40, 70)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon_key.fef498ca3a4c63cb934b5200ca18a0ac.svg";
export { ForwardRef as ReactComponent };